import { blue, generate, green, presetPalettes, red } from '@ant-design/colors';
import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { ColorPicker, Dropdown, Space, Switch } from 'antd';
import TableAntd from 'components/elements/Table/Table';
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// import formatDateTime from "utils/formatter/formatDateTime";

const ShiftsListTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onStatus = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onColor = () => { },
  onView = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  console.log("pagination", pagination);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    if (i18n.language === "en") {
      return date.format("DD/MM/YYYY HH:mm");
    } else {
      return `${date.format(`DD/MM/${date.year() + 543}`)} ${date.format('HH:mm')} น.`;
    }
  }

  const genPresets = (presets = presetPalettes) =>
    Object.entries(presets).map(([label, colors]) => ({
      label,
      colors,
    }));

  const columns = [
    {
      title: <div className="text-table">{t('attendance.no')}.</div>,
      dataIndex: "index",
      key: "index",
      render: (_, record, idx) => {
        const currentPage = pagination.current || 1;
        const pageSize = pagination.size || 10;
        console.log("sssss", currentPage, pageSize, idx);

        return (currentPage - 1) * pageSize + (idx + 1);
      },
    },
    {
      title: <div className="text-table">{t('attendance.shift-name')}</div>,
      dataIndex: "shiftName",
      key: "shiftName",
      sorter: (a, b) => a.shiftName.length - b.shiftName.length,
      render: (_, row) => {
        return i18n.language === "en" && row.shiftNameEn
          ? row.shiftNameEn
          : row.shiftName;
      },
    },
    {
      title: <div className="text-table">{t('attendance.shift-code')}</div>,
      dataIndex: "shiftCode",
      key: "shiftCode",
      sorter: (a, b) => a.shiftCode.length - b.shiftCode.length,
    },
    {
      title: <div className="text-table">{t('attendance.description')}</div>,
      dataIndex: "description",
      key: "description",
    },
    {
      title: <div className="text-table">{t('attendance.color-code')}</div>,
      dataIndex: "colorCode",
      key: "colorCode",
      render: (_, record) => {
        const color = record.colorCode || "#1677ff";
        const presets = genPresets({
          primary: generate(color),
          red,
          green,
          blue
        });
        return (
          <ColorPicker
            format="hex"
            value={color}
            presets={presets}
            onChangeComplete={(color) => {
              const tinycolor = color.metaColor; // ดึง metaColor
              const hexColor = tinycolor.toHexString(); // แปลงเป็น hex
              onColor({ colorCode: hexColor, attendanceSettingShiftId: record.id });
            }}
          />

        );
      }
    },
    {
      title: <div className="text-table">{t('attendance.last-modified')}</div>,
      dataIndex: "modified",
      key: "modified",
      render: (_, record) => {
        if (record?.update?.nameEn !== null) {
          return (
            <>
              {i18n.language === 'en' ? record?.update?.nameEn + " " + record?.update?.surnameEn : record?.update?.name + " " + record?.update?.surname}
              <br />
              {record?.update?.date ? formatDate(record?.update?.date) : "-"}
            </>
          )
        } else {
          return (
            <>
              {i18n.language === 'en' ? record?.create?.nameEn + " " + record?.create?.surnameEn : record?.create?.name + " " + record?.create?.surname}
              <br />
              {record?.create?.date ? formatDate(record?.create?.date) : "-"}
            </>
          )
        }
      },
    },
    {
      title: <div className="text-table">{t('attendance.status')}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={!roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|SHIFT")}
        />
      ),
    },
    {
      title: <div className="text-table">{t('attendance.action')}</div>,
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "0",
                  onClick: () => onView(record),
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|SHIFT") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_CONFIGURATION|ATTENDANCE_SETTING|SHIFT") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
        onChange: (page, pageSize) => pagination.onChange(page, pageSize),

      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      scroll={{ x: true }}
    />
  );
};

export default ShiftsListTable;
